<!--增加删除修改详情通用组件-->
<template>
  <Form
    ref="form"
    :class="['form-list',type]"
    :label-width="labelWidth"
    :label-position="labelPosition"
    :model="params"
  >
    <MyFormItemList
      v-model="params"
      :type="type"
      :list="formItems"
      :form-item-width="formItemWidth"
      :label-width="labelWidth"
    />
    <slot name="footer">
      <div style="text-align: center; margin-top: 50px;">
        <Button
          v-if="type!='detail'"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
        >
          {{ confirmText }}
        </Button>
        <Button
          v-if="cancelText"
          style="margin-left: 10px;"
          @click="close"
        >
          {{ cancelText }}
        </Button>
      </div>
    </slot>
  </Form>
</template>

<script>
import MyFormItemList from '@/components/Form/FormItemList';

export default {
  components: { MyFormItemList },
  props: {
    cancelText: {
      type: String,
      default: '取消',
    },
    confirmText: {
      type: String,
      default: '确认',
    },
    formItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: 'add',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: Number,
      default: 100,
    },
    formItemWidth: {
      type: Number,
      default: 0,
    },
    labelColon: {
      type: Boolean,
      default: true,
    },
    labelPosition: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      params: this.value,
    };
  },
  watch: {
    params: {
      handler() {
        if (this.value !== this.params) {
          this.$emit('input', this.params);
        }
      },
      deep: true,
    },
    value: {
      handler() {
        if (this.value !== this.params) {
          this.params = this.value;
        }
      },
      // immediate:true
      deep: true,
    },
  },
  created() {

  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('on-submit', this);
        }
      });
    },
    close() {
      if (this.$listeners['on-close']) {
        this.$emit('on-close');
      } else {
        this.$router.back();
      }
    },
    validate(callback) {
      this.$refs.form.validate(callback);
    },
  },
};
</script>
